export default {
  // BASE_URL: 'http://api-maxweb.gz.cvte.cn/mock/41',
  BASE_URL: '',
  FRIDAY_TRACKER_ID: 'ecb6c2aa9c4d4b9d95b0563a322dd245',
  // 高德地图安全代理（已弃用，保留用于回滚）
  AMAP_SERCURITY_HOST: 'http://127.0.0.1:7001/_AMapService',
};



// WEBPACK FOOTER //
// ./src/config/config.local.js